export const TYPES = {
	text: 'uiProperty-typeText',
	map: 'uiProperty-typeMap',
	sideBar: 'uiProperty-typeSidebar'
};
